<template>
  <div>
    <div class="columns is-vcentered is-centered">
      <div class="column auto">
        <div v-if="$i18n.locale == 'fr'">
          <figure class="widget-teaser-l">
            <b-tooltip :label="tooltipFr" position="is-bottom">
              <img
                :src="widget.imgSrcFr"
                :alt="tooltipFr"
                class="img-is-rounded mrgn-bttm-sm"
              />
            </b-tooltip>
          </figure>
        </div>
        <div v-else>
          <figure class="widget-teaser-l">
            <b-tooltip :label="tooltip" position="is-bottom">
              <img
                :src="widget.imgSrc"
                :alt="tooltip"
                class="img-is-rounded mrgn-bttm-sm"
              />
            </b-tooltip>
          </figure>
        </div>
      </div>
      <div class="column is-7">
        <figcaption>
          <p class="subtitle" v-html="$t('widget_details.example_title')"></p>
        </figcaption>
        <div v-if="$i18n.locale == 'en'" v-html="widget.exampleText"></div>
        <div v-if="$i18n.locale == 'fr'" v-html="widget.exampleTextFr"></div>
      </div>
    </div>
    <div class="columns is-vcentered is-centered">
      <div v-if="widget.id == '3'" class="column is-12">
        <div v-if="$i18n.locale == 'en'" v-html="widget.exampleTextLong"></div>
        <div
          v-if="$i18n.locale == 'fr'"
          v-html="widget.exampleTextLongFr"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetExample",
  props: {
    widget: { type: Object, required: true }
  },
  data: function() {
    return {
      tooltip: this.widget.name + " example",
      tooltipFr: "Exemple pour " + this.widget.nameFr
    };
  }
};
</script>
<style lang="scss">
.image .widget-image-l {
  max-width: 280px;
  max-height: 280px;
}
/* teaser image css */
.widget-teaser-l {
  position: relative;
  max-height: 280px;
  max-width: 280px;
  min-height: 200px;
  min-width: 200px;
}
.widget-teaser-l img {
  border-radius: 100%;
  width: 100%;
  height: auto;
}
.widget-teaser-l::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  box-shadow: inset 20px 20px 30px rgba(0, 0, 0, 0.09),
    inset -16px -16px 20px rgba(0, 0, 0, 0.04);
}
</style>
